export default __webpack_public_path__ + "static/media/logo-facebook.1d8e0397.svg";